/* eslint-disable no-undef */

import React, { useEffect, useState } from "react";
import fetchData from "../../functions/fetchData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { getHeaders } from "../../utility/getHeader";
import Header from "../../components/Header";
import Layout from "../../layout/Layout";
import DataTable from "../../components/data-tables/datatwoTable";
import { Form, Input, Select, Button, Row, Col, Card, Typography, Space, Divider, Statistic, Empty } from "antd";
import { SaveOutlined, CreditCardOutlined } from "@ant-design/icons";

export default function PaymentVouchers() {
    const [suppliers, setsuppliers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [outstandingAmount, setOutstandingAmount] = useState(0);
    const [paymentAmount, setPaymentAmount] = useState("");
    const [paymentMode, setPaymentMode] = useState("");
    const [referenceNumber, setReferenceNumber] = useState("");
    const [remarks, setRemarks] = useState("");
    const [balanceAfterPayment, setBalanceAfterPayment] = useState(0);
    const [invoices, setInvoices] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState("");
    const [data, setData] = useState([]);
    const columns = [
 
        { label: "Supplier ID", field: "supplier_id" },
        { label: "Date", field: "payment_date" },
        { label: "Mode", field: "payment_mode" },
        { label: "Paid Amount", field: "amount_paid" },
        { label: "Ref ID", field: "reference_id" }
    ];
    // Fetch suppliers when component loads
    useEffect(() => {
        // fetchData("suppliers", setsuppliers);
        fetchData("suppliers", setsuppliers, "id", {});
    }, []);

    const getOutStandingBalance = async (e) => {
        const customerId = e.target.value;
        setSelectedCustomer(customerId); // Update selected customer state

        if (!customerId) {
            setOutstandingAmount(0);
            return;
        }

        //testing update upto 15may 2025
        try {
            const res = await axios.get(`/getoutstandingbalance/Purchase/${customerId}`, getHeaders());
            if (res.data.success) {
                setOutstandingAmount(res.data.outstanding_balance);
            } else {
                toast.error("Failed to fetch ledger balance");
            }
        } catch (error) {
            console.error("Error fetching outstanding balance:", error);
            toast.error("Error fetching outstanding balance.");
        }
    };

    useEffect(() => {
        const remaining = outstandingAmount - (parseFloat(paymentAmount) || 0);
        setBalanceAfterPayment(remaining >= 0 ? remaining : 0);
    }, [paymentAmount, outstandingAmount]);

    // Fetch outstanding balance & invoices when a customer is selected
    useEffect(() => {
        // alert(selectedCustomer);
        if (selectedCustomer) {
            // Fetch ledger balance from API
            
            fetchData("suppliers", setsuppliers, "id", {});
            axios.get(`/getoutstandingbalance/Purchase/${selectedCustomer}`, getHeaders(), (res) => {
                if (res.success) {
                    setOutstandingAmount(res.outstanding_balance);
                    alert(res.outstanding_balance);
                    <input type="text" value={`฿ ${outstandingAmount}`} readOnly className="form-control" />
                    console.log(outstandingAmount);
                } else {
                    alert("error");
                    console.log("error");
                    toast.error("Failed to fetch ledger balance");
                }
            });

            // Fetch invoices related to the customer
            //  fetchData(`/getCustomerInvoices/${selectedCustomer}`, setInvoices);
        } else {
            setOutstandingAmount(0);
            setInvoices([]);
        }
    }, [selectedCustomer]);

useEffect(() => {
  const fetchAndSetData = async () => {
    try {
      await fetchData("payment_vouchers", setData, "id", {});
      console.log("Fetched data:", data);
    } catch (error) {
      console.error("Error in useEffect:", error);
    }
  };

  fetchAndSetData();
}, []);

    // Update remaining balance after payment
    useEffect(() => {

        const remaining = outstandingAmount - paymentAmount;
        setBalanceAfterPayment(remaining >= 0 ? remaining : 0);
    }, [paymentAmount, outstandingAmount]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const paymentData = {
            supplier_id: selectedCustomer,
            amount_paid: parseFloat(paymentAmount) || 0,
            reference_number: referenceNumber,
            payment_mode: paymentMode,
            remarks, remarks// ✅ add this
        };
if (!selectedCustomer || !paymentAmount || !paymentMode) {
  toast.error("Please fill in all required fields.");
  return;
}
//console.log("Sending payment data:", paymentData);

        try {
            await axios.post(
                "/saveSupplierPayment", paymentData, getHeaders()
            );
            // Send the data to the backend using POST
            //await fetchData("payment_vouchers", null, "POST", paymentData);
 await fetchVoucherData();
            toast.success("Payment recorded successfully!");
        } catch (error) {
            console.error("Error saving payment:", error);
            toast.error("Error recording payment."+error);
        }
    };
const fetchVoucherData = async () => {
  try {
    await fetchData("payment_vouchers", setData, "id", {});
  } catch (error) {
    console.error("Error fetching payment vouchers:", error);
  }
};


    return (
        <Layout>
            <Header title="Payment Vouchers" />
            <ToastContainer />

            <div style={{ padding: "24px" }}>
                <Row gutter={[24, 24]}>
                    {/* Left Panel - Payment Form */}
                    <Col xs={24} sm={24} md={10} lg={9}>
                        <Card
                            title={
                                <Space>
                                    <CreditCardOutlined style={{ color: "#1677ff" }} />
                                    <span>New Payment</span>
                                </Space>
                            }
                            bordered={false}
                            style={{ boxShadow: "0 1px 2px rgba(0,0,0,0.03)" }}
                        >
                            <Form 
                                layout="vertical" 
                                onFinish={handleSubmit} 
                                requiredMark="optional"
                                colon={false}
                            >
                                <Form.Item label="Supplier" required name="supplier">
                                    <Select
                                        value={selectedCustomer || undefined}
                                        onChange={getOutStandingBalance}
                                        placeholder="Select a supplier"
                                        options={suppliers.map((customer) => ({
                                            value: customer.id,
                                            label: customer.name,
                                        }))}
                                    />
                                </Form.Item>

                                <Form.Item label="Outstanding Amount">
                                    <Statistic 
                                        value={outstandingAmount} 
                                        prefix="฿" 
                                        precision={2}
                                        valueStyle={{ color: "#262626", fontSize: "16px" }}
                                    />
                                </Form.Item>

                                <Divider style={{ margin: "16px 0" }} />

                                <Form.Item label="Payment Mode" required name="mode">
                                    <Select
                                        value={paymentMode || undefined}
                                        onChange={(value) => setPaymentMode(value)}
                                        placeholder="Select payment mode"
                                        options={[
                                            { value: "Cash", label: "Cash" },
                                            { value: "Bank", label: "Bank" },
                                            { value: "Cheque", label: "Cheque" },
                                            { value: "Online", label: "Online" },
                                        ]}
                                    />
                                </Form.Item>

                                <Form.Item label="Amount Paid" required name="amount">
                                    <Input
                                        type="number"
                                        value={paymentAmount}
                                        onChange={(e) => setPaymentAmount(e.target.value)}
                                        placeholder="0.00"
                                        prefix="฿"
                                    />
                                </Form.Item>

                                <Form.Item label="Reference Number" name="reference">
                                    <Input
                                        value={referenceNumber}
                                        onChange={(e) => setReferenceNumber(e.target.value)}
                                        placeholder="Enter reference (optional)"
                                    />
                                </Form.Item>

                                <Form.Item label="Remarks" name="remarks">
                                    <Input.TextArea
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        placeholder="Add remarks (optional)"
                                        rows={3}
                                    />
                                </Form.Item>

                                <Divider style={{ margin: "16px 0" }} />

                                <Form.Item>
                                    <Space direction="vertical" style={{ width: "100%" }}>
                                        <div>
                                            <Typography.Text type="secondary" style={{ fontSize: "12px" }}>
                                                Balance After Payment
                                            </Typography.Text>
                                            <div style={{ marginTop: "8px" }}>
                                                <Statistic 
                                                    value={balanceAfterPayment} 
                                                    prefix="฿" 
                                                    precision={2}
                                                    valueStyle={{ color: "#1677ff", fontSize: "18px", fontWeight: "600" }}
                                                />
                                            </div>
                                        </div>
                                    </Space>
                                </Form.Item>

                                <Form.Item style={{ marginTop: "24px", marginBottom: 0 }}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        block
                                        size="large"
                                        icon={<SaveOutlined />}
                                    >
                                        Save Payment
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>

                    {/* Right Panel - Payment History */}
                    <Col xs={24} sm={24} md={14} lg={15}>
                        <Card
                            title={<span>Payment History</span>}
                            bordered={false}
                            style={{ boxShadow: "0 1px 2px rgba(0,0,0,0.03)" }}
                        >
                            {data.length === 0 ? (
                                <Empty 
                                    description="No payment records" 
                                    style={{ padding: "60px 0" }}
                                />
                            ) : (
                                <div style={{ overflowX: "auto" }}>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        tablename={{ main: "payment_vouchers", join: "suppliers" }}
                                    />
                                </div>
                            )}
                        </Card>
                    </Col>
                </Row>
            </div>
        </Layout>
    );
}
